import NamedDto from 'modules/base/dto/NamedDto';

export class ProfileEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {string} */
		this.magic = null;
		/** @type {string} */
		this.status = null;
		/** @type {number} */
		this.visualCaptchaType = null;
		/** @type {number} */
		this.audioCaptchaType = null;
	}

	/**
	 * @typedef {Object} _ProfileEditDtoProps
	 * @property {string} magic
	 * @property {string} status
	 * @property {number} visualCaptchaType
	 * @property {number} audioCaptchaType
	 * @typedef {import("../NamedDto").NamedDtoProps & _ProfileEditDtoProps} ProfileEditDtoProps
	 */
	/**
	 *
	 * @param {ProfileEditDtoProps} props
	 * @returns {ProfileEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.magic = props.magic;
		this.status = props.status;
		this.visualCaptchaType = props.visualCaptchaType;
		this.audioCaptchaType = props.audioCaptchaType;
		return this;
	}
}

export default ProfileEditDto;
